import React from 'react';
import { useTranslations } from 'next-intl';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';

interface ConfirmationModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  isLoading = false,
}) => {
  const t = useTranslations('Confirmation.Unsubscribe');

  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onCancel()}>
      <DialogContent className='w-11/12 max-w-md rounded-lg p-0'>
        {/* Header */}
        <div className='flex items-center justify-center border-gray-200 px-6 pt-4'>
          <DialogTitle className='text-xl font-semibold'>
            {t('title')}
          </DialogTitle>
        </div>

        {/* Content */}
        <div className='px-6 py-4'>
          <p className='mb-6 text-center text-gray-700'>{t('message')}</p>

          <div className='space-y-4'>
            <div className='flex flex-col gap-3'>
              <button
                onClick={handleConfirm}
                disabled={isLoading}
                className={`w-full rounded-lg px-4 py-2 text-sm font-medium transition-colors ${
                  isLoading
                    ? 'cursor-not-allowed bg-gray-200 text-gray-400'
                    : 'bg-red-500 text-white hover:bg-red-600'
                }`}
              >
                {isLoading ? t('processing') : t('confirm')}
              </button>

              <button
                onClick={handleCancel}
                disabled={isLoading}
                className='w-full rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50'
              >
                {t('cancel')}
              </button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationModal;
